import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React, { forwardRef } from 'react';
import { PrimaryStyledLink, RepositionedChevron } from '../styles';
import { useLinkBehavior } from '../shared';
var ChevronLink = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'medium' : _ref$size,
      _ref$chevronDirection = _ref.chevronDirection,
      chevronDirection = _ref$chevronDirection === void 0 ? 'right' : _ref$chevronDirection,
      dataTest = _ref['data-test'],
      linkProps = _objectWithoutProperties(_ref, ["children", "size", "chevronDirection", "data-test"]);

  var _useLinkBehavior = useLinkBehavior(linkProps),
      linkBehavior = _extends({}, _useLinkBehavior);

  return /*#__PURE__*/React.createElement(PrimaryStyledLink, _extends({}, linkProps, linkBehavior, {
    size: size,
    ref: ref,
    "data-test": dataTest ? dataTest : undefined
  }), children, /*#__PURE__*/React.createElement(RepositionedChevron, {
    size: "xsmall",
    pointing: chevronDirection
  }));
});
ChevronLink.displayName = 'ChevronLink';
export default ChevronLink;